import * as actionTypes from '../types/modalError';

export function modalErrorOpen(payload) {
  return {
    type: actionTypes.MODAL_ERROR_OPEN,
    payload
  };
}

export function modalErrorClose(payload) {
  return {
    type: actionTypes.MODAL_ERROR_CLOSE,
    payload
  };
}
